import { Dialog } from "primereact/dialog"
import { NIST, ZT } from "./ZeroTrustData"
import { Button } from "primereact/button"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { Tag } from "primereact/tag"
import { PD, statusLookup } from "../DataManagement/DataManagement"
import { useEffect, useState } from "react"
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { getThreatRangeText } from "../MITREAttack/TagAttack"

export default function ZeroTrustDialogPopup(props: any) {
    const [ztDataTable, setZTDataTable] = useState<any>([]);

    useEffect(() => {
        let newDataTable:any = [];
        if(!props.ztA.selectedCtr) return;
        ZT.ztmap?.[props.ztA.selectedCtr].forEach((nid:any) => {
            newDataTable.push({
                status: PD?.controls?.[nid]?.status || 'None',
                nid: nid,
                name: NIST.controls[nid].name,
                j: PD?.controls?.[nid]?.j || '-',
            })
        });
        setZTDataTable(newDataTable);
    }, [props.ztA.selectedCtr]);

    const popupHeader = () => {
        return(
            <>
                {`${props.ztA.selectedCtr} ${ZT.controls['zt-'+props.ztA.selectedCtr].name}`}
            </>
        )
    }

    const statusBody = (rowData:any) => {
        const status = statusLookup?.[rowData.status]?.severity || 'danger';
        return(
            <Tag value={rowData.status} severity={status} rounded style={{width: '100%', textAlign: 'center'}}/>
        )
    }

    const threatText = getThreatRangeText(ZT?.prevalence?.[props.ztA.selectedCtr]?.norm);

    return (
        <Dialog header={popupHeader} visible={props.ztA.showPopup}
            style={{ width: '75vw', height: 'auto' }}
            onHide={() => props.ztDispatch({ type: 'closePopup' })}
            modal={false}
            className=''>
            <Container>
                <Row>
                    <Col sm={4} className="flex d-flex flex-column gap-1">
                        <Row>
                            <div>
                                <strong>Phase: </strong>
                                {ZT.controls[`zt-${props.ztA.selectedCtr}`].phase} [{ZT.controls[`zt-${props.ztA.selectedCtr}`].m}/months]
                            </div>
                        </Row>
                        <Row style={{ alignItems: 'center', gap: '1rem' }}>
                            <div className="flex d-flex gap-1 align-items-center">
                                <strong>Predecessor(s):</strong>
                                {ZT.controls[`zt-${props.ztA.selectedCtr}`].predecessor.map((pred: any) => {
                                    return (
                                        <Button className='zt-btn zt-btn-small' size='small' label={pred} outlined onClick={() => props.ztDispatch({ type: 'setPopup', payload: pred })} />
                                    )
                                })}
                            </div>
                        </Row>
                        <Row >
                            <div className="flex d-flex gap-1 align-items-center">
                                <strong>Successor(s):</strong>
                                {ZT.controls[`zt-${props.ztA.selectedCtr}`].successor.map((succ: any) => {
                                    return (
                                        <Button className='zt-btn zt-btn-small' size='small' label={succ} outlined onClick={() => props.ztDispatch({ type: 'setPopup', payload: succ })} />
                                    )
                                })}
                            </div>
                        </Row>
                        <Row>
                            <div>
                                <strong>Threat Level: </strong>
                                {threatText}
                            </div>
                        </Row>
                    </Col>
                    <Col sm={8}>
                        <strong>Description:</strong> {ZT.controls[`zt-${props.ztA.selectedCtr}`].description}
                    </Col>
                </Row>
                <Row style={{marginTop: '0.25rem'}}>
                    <div>
                        <strong>Expected Outcomes:</strong>
                        <ol>
                        {ZT.controls[`zt-${props.ztA.selectedCtr}`].outcomes.map((outcome: String, i: number) => {
                            return (<li key={props.ztA.selectedCtr + 'eo' + i}>
                                {outcome}
                            </li>)
                        })}
                        </ol>
                    </div>
                </Row>
                <Row>
                    <DataTable value={ztDataTable}
                        tableStyle={{ minWidth: '50rem' }}
                        scrollHeight="400px" scrollable
                        header={<>NIST 800-53 Control Mappings</>}
                    >
                        <Column field="status" header="Status" style={{ minWidth: '4rem' }} sortable body={statusBody}></Column>
                        <Column field="nid" header="Control" style={{ minWidth: '4rem' }} sortable></Column>
                        <Column field="name" header="Name" style={{ minWidth: '10rem' }}></Column>
                        <Column field="j" header="Justification" style={{ maxWidth: '50%' }}></Column>
                    </DataTable>
                </Row>
            </Container>
        </Dialog>
    )
}